import {isNumeric} from "../helpers/common.helper";

export function ValidatePhone(type:string,phone:string){

  let isValid:boolean = false;
  return !phone || phone === '' || isNumeric(phone);
  if(type === 'telefono_1'){
    isValid = (/^(?:(?:(?:\+|00)34\D?))?(?:6)(?:\d\D?){8}$/).test(phone);
    if(phone === '' || isValid) return true;
    return isValid;
  }
  else if (type === 'telefono_2'){
    isValid = (/^(?:(?:(?:\+|00)34\D?))?(?:9)(?:\d\D?){8}$/).test(phone);
    if(phone === '' || isValid) return true;
    return isValid;
  }
  else return isValid;

  // Mexican
  // isValid = (/(\(\d{3}\)[.-]?|\d{3}[.-]?)?\d{3}[.-]?\d{4}/).test(phone);

  // Portugal
  // isValid = (/^(9|2{1})+([1-9]{1})+([0-9]{7})$/).test(phone)

  //TODO Falta telefono colombiano.
}
